import withSkeleton from './withSkeleton';

export default withSkeleton;
